// extracted by mini-css-extract-plugin
export default {"moodWindow":"MoodWindow_moodWindow__SEYUr","MoodWrapper":"MoodWindow_MoodWrapper__8iNvb","trail":"MoodWindow_trail__9kenP"};